import "antd/es/message/style";
import _message from "antd/es/message";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useReducer } from 'react';
import partial from 'lodash.partial';
import classNames from 'classnames';
import { useInterval } from '@huse/timeout';
import { IconCheckCircleFilled, IconCloseCircleFilled, IconInfoCircleFilled, IconExclamationCircleFilled, IconCloseOutlined } from '@osui/icons';
import { getGlobalConfig } from '@osui/config-provider';
import './index.less';
var clsPrefix = 'osui-message';
var DEFAULT_DURATION = 5;
var typeToIcon = {
  info: /*#__PURE__*/React.createElement(IconInfoCircleFilled, {
    className: "".concat(clsPrefix, "-infoIcon")
  }),
  success: /*#__PURE__*/React.createElement(IconCheckCircleFilled, {
    className: "".concat(clsPrefix, "-successIcon")
  }),
  error: /*#__PURE__*/React.createElement(IconCloseCircleFilled, {
    className: "".concat(clsPrefix, "-errorIcon")
  }),
  warning: /*#__PURE__*/React.createElement(IconExclamationCircleFilled, {
    className: "".concat(clsPrefix, "-warningIcon")
  })
};

function isObject(content) {
  return Object.prototype.toString.call(content) === '[object Object]';
}

var CountDownClose = function CountDownClose(_ref) {
  var countDown = _ref.countDown,
      onTimeout = _ref.onTimeout;

  var _useReducer = useReducer(function (state) {
    return state - 1;
  }, countDown),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      timer = _useReducer2[0],
      reduce = _useReducer2[1];

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1]; // 每秒调用一次


  useInterval(reduce, 1 * 1000);
  useEffect(function () {
    if (timer < 0) {
      // onTimeout();
      setShow(false);
    }
  }, [timer, countDown, onTimeout]);

  if (countDown <= 0) {
    return null;
  }

  return show && /*#__PURE__*/React.createElement("span", {
    className: "".concat(clsPrefix, "-count-down-close")
  }, "(", timer, "s)") || null;
};

var localInnerKey = 0; // 用来记录message destory的
// eslint-disable-next-line complexity

var getMessageContent = function getMessageContent(_ref2) {
  var _content$content;

  var content = _ref2.content,
      className = _ref2.className,
      key = _ref2.key,
      onClose = _ref2.onClose,
      duration = _ref2.duration,
      onClick = _ref2.onClick;

  var _ref3 = isObject(content) ? content : {},
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title,
      _ref3$showClose = _ref3.showClose,
      showClose = _ref3$showClose === void 0 ? true : _ref3$showClose,
      _ref3$showCountDown = _ref3.showCountDown,
      showCountDown = _ref3$showCountDown === void 0 ? true : _ref3$showCountDown,
      _ref3$duration = _ref3.duration,
      innerDuration = _ref3$duration === void 0 ? duration !== null && duration !== void 0 ? duration : DEFAULT_DURATION : _ref3$duration,
      _ref3$key = _ref3.key,
      innerKey = _ref3$key === void 0 ? key : _ref3$key,
      _ref3$onClose = _ref3.onClose,
      innerOnClose = _ref3$onClose === void 0 ? onClose : _ref3$onClose;

  var realContent = isObject(content) ? (_content$content = content.content) !== null && _content$content !== void 0 ? _content$content : null : content;
  var innerContent = null;

  var handleClose = function handleClose() {
    _message.destroy(innerKey);

    innerOnClose && innerOnClose();
  };

  var countDown = showCountDown && /*#__PURE__*/React.createElement(CountDownClose, {
    countDown: innerDuration || -1,
    // eslint-disable-next-line react/jsx-no-bind
    onTimeout: handleClose
  });
  var closeIcon = showClose &&
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-bind
  React.createElement("span", {
    className: "close-icon",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(IconCloseOutlined, null));

  if (title) {
    // content with title;
    innerContent = /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-message-content")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-message-content-title")
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(clsPrefix, "-message-content-title-text")
    }, title), countDown, closeIcon), /*#__PURE__*/React.createElement("div", null, realContent));
  } else {
    innerContent = /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(clsPrefix, "-message-content"), "".concat(clsPrefix, "-message-content-inline"))
    }, realContent, countDown, closeIcon);
  }

  return {
    content: innerContent,
    className: className,
    key: innerKey,
    duration: innerDuration,
    onClose: innerOnClose,
    onClick: onClick
  };
}; // 对antd message args的调整


var getPatchedArgs = function getPatchedArgs(args) {
  var _args$content;

  var getPropFromConfig = function getPropFromConfig(prop) {
    return args.content && args.content[prop] || args[prop];
  };

  if (getPropFromConfig('original')) {
    // 如果传入original为true则只覆盖icon和className
    var contentConfig = isObject(args.content) ? args.content : {};
    return _objectSpread(_objectSpread(_objectSpread({}, args), contentConfig), {}, {
      className: classNames(clsPrefix, getPropFromConfig('className')),
      icon: getPropFromConfig('icon') || typeToIcon[args.type]
    });
  } // 如果传入original为false，则使用自定义组件作为content，使用自定义组件作为content时


  var content = args.content;
  var type = getPropFromConfig('type');
  var icon = getPropFromConfig('icon') || typeToIcon[args.type];
  var key = getPropFromConfig('key') || args.localInnerKey;
  var duration = getPropFromConfig('duration');
  var onClose = getPropFromConfig('onClose');
  var onClick = getPropFromConfig('onClick');

  var _getGlobalConfig = getGlobalConfig(),
      messagePosition = _getGlobalConfig.messagePosition;

  var className = classNames(clsPrefix, "".concat(clsPrefix, "-message-").concat(type), "".concat(clsPrefix, "-message-at-").concat(messagePosition), getPropFromConfig('className'), _defineProperty({}, "".concat(clsPrefix, "-message-with-title"), getPropFromConfig('title')), _defineProperty({}, "".concat(clsPrefix, "-message-with-title-only"), !((_args$content = args.content) !== null && _args$content !== void 0 && _args$content.content))); // 这里对countDown做了处理，duration不能直接透传给countDown，考虑到有可能有自动关闭，但是不想显示倒计时的场景

  return _objectSpread(_objectSpread(_objectSpread({}, args), getMessageContent({
    content: content,
    className: className,
    key: key,
    duration: duration,
    onClose: onClose,
    onClick: onClick
  })), {}, {
    icon: icon
  });
};

var messageBuilder = function messageBuilder(type, content, duration, onClose) {
  localInnerKey++;

  if (typeof duration === 'function') {
    // 为了支持第二个参数是onClose
    return _message.open(getPatchedArgs({
      type: type,
      content: content,
      duration: DEFAULT_DURATION,
      onClose: duration,
      localInnerKey: localInnerKey // 这个是额外加的，只内部使用

    }));
  }

  return _message.open(getPatchedArgs({
    type: type,
    content: content,
    duration: duration,
    onClose: onClose,
    localInnerKey: localInnerKey // 这个是额外加的，只内部使用

  }));
};

var openMessageBuilder = function openMessageBuilder(args) {
  return _message.open(getPatchedArgs(args));
};

export default Object.assign({}, _message, {
  success: partial(messageBuilder, 'success'),
  error: partial(messageBuilder, 'error'),
  warning: partial(messageBuilder, 'warning'),
  info: partial(messageBuilder, 'info'),
  warn: partial(messageBuilder, 'warning'),
  loading: partial(messageBuilder, 'loading'),
  notify: partial(messageBuilder, 'notify'),
  open: openMessageBuilder,
  config: function config(options) {
    // 对antd message config的patch，注意还不支持context的方式
    _message.config(options);
  },
  destroy: _message.destroy,
  useMessage: _message.useMessage
});
//# sourceMappingURL=index.js.map